import { render, staticRenderFns } from "./compose.vue?vue&type=template&id=1c8da58c&scoped=true&"
import script from "./compose.vue?vue&type=script&lang=js&"
export * from "./compose.vue?vue&type=script&lang=js&"
import style0 from "./compose.vue?vue&type=style&index=0&id=1c8da58c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8da58c",
  null
  
)

export default component.exports